import { Directive, ElementRef, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportScaleService } from '../services/viewport-scale.service';

/**
 * Директива автоматического масштабирования.
 * Навешивается на корневой элемент приложения.
 * Применяет CSS zoom, рассчитанный ViewportScaleService.
 *
 * Использование:  <div appAutoScale> ... </div>
 */
@Directive({
  selector: '[appAutoScale]',
  standalone: true,
})
export class AutoScaleDirective implements OnInit, OnDestroy {
  private sub!: Subscription;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private scaleService: ViewportScaleService
  ) {}

  ngOnInit(): void {
    // Устанавливаем базовые стили хоста для корректного масштабирования
    this.renderer.setStyle(this.el.nativeElement, 'transform-origin', 'top left');
    this.renderer.setStyle(this.el.nativeElement, 'width', '100%');

    this.sub = this.scaleService.scale$.subscribe((scale) => {
      // CSS zoom поддерживается всеми современными браузерами (Chrome, Edge, Safari, Firefox 126+)
      this.renderer.setStyle(this.el.nativeElement, 'zoom', `${scale}`);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
